export const firebaseConfig = {
  apiKey: "AIzaSyC-1VvsOMeIpmuR1_YM0IJQbg_gx9G4rrc",
  authDomain: "brea-394006.firebaseapp.com",
  projectId: "brea-394006",
  storageBucket: "brea-394006.appspot.com",
  messagingSenderId: "602119399252",
  appId: "1:602119399252:web:4a11fe5d62009373c78ac1",
  measurementId: "G-TZBG9YYRL3",
};
